import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * GG: przy ilości == min (1) przycisk "−" zamienia się w KOSZ (usuwa pozycję) zamiast być
 * wyłączony — dzięki temu nie potrzeba osobnego przycisku "USUŃ".
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits.
   * GG: przy ilości 1 NIE wyłączamy "−" — dostaje klasę `is-remove` (CSS pokazuje ikonę kosza),
   * a klik usuwa pozycję (patrz decreaseQuantity). Powyżej minimum normalny minus.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    const atMin = value <= min;
    minusButton.disabled = false;
    minusButton.classList.toggle('is-remove', atMin);
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * GG override: przy ilości == min (1) "−" działa jak kosz i usuwa pozycję z koszyka
   * (klika ukryty programowo przycisk `.cart-items__remove` tego wiersza). Powyżej minimum
   * normalne zmniejszanie.
   * @param {Event} [event]
   */
  decreaseQuantity(event) {
    const { min, value } = this.getCurrentValues();
    if (value <= min) {
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      const controls =
        this.closest('.cart-items__quantity-controls') || this.closest('.cart-items__table-row');
      const removeBtn = controls && controls.querySelector('.cart-items__remove');
      if (removeBtn) {
        removeBtn.click();
        return;
      }
    }
    super.decreaseQuantity(event);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
